export default __webpack_public_path__ + "static/media/new_download_icon_active.3602919d.svg";